
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
	name: 'FulfillmentOptionDisclaimer',
})
class FulfillmentOptionDisclaimer extends Vue { }

export default FulfillmentOptionDisclaimer;
